import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  dragIcon: {
    // Keep the outline's drawn bounds near the legacy rule grip.
    transform: 'scale(1.8, 1.3)',
  },
  dragHandle: {
    cursor: 'grab',
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1),
    color: theme.palette.common.gray500,
    '&:active': {
      cursor: 'grabbing',
    },
  },
  paddingBottom: {
    paddingBottom: theme.spacing(3),
  },
  paddingTop: {
    paddingTop: theme.spacing(3),
  },
  ruleCardContainer: {
    marginBottom: theme.spacing(3),

    '&:last-child': {
      marginBottom: 0,
    },
  },
  trashcanIcon: {
    fontSize: theme.spacing(1.5),
    marginRight: theme.spacing(1),
  },
}));
